import { render, staticRenderFns } from "./CompItem.vue?vue&type=template&id=402d638c&"
import script from "./CompItem.vue?vue&type=script&lang=js&"
export * from "./CompItem.vue?vue&type=script&lang=js&"
import style0 from "./CompItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports